export default __webpack_public_path__ + "static/media/AI Concierge.be817050.svg";